var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpender = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_2528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2758 18.4477V18.9766C15.2758 19.2684 15.0395 19.5055 14.7469 19.5055H9.46094C9.16912 19.5055 8.93203 19.2692 8.93203 18.9766V9.46094C8.93203 9.16912 9.16833 8.93203 9.46094 8.93203H9.725C10.0168 8.93203 10.2539 9.16912 10.2539 9.46094C10.2539 9.75275 10.4902 9.98985 10.7828 9.98985H13.4258C13.7176 9.98985 13.9547 9.75354 13.9547 9.46094C13.9547 9.16912 14.191 8.93203 14.4836 8.93203H14.7477C15.0395 8.93203 15.2766 9.16833 15.2766 9.46094V9.98985C15.2766 10.2817 15.5129 10.5188 15.8055 10.5188C16.0973 10.5188 16.3344 10.2825 16.3344 9.98985V9.46094C16.3344 8.58471 15.6247 7.875 14.7485 7.875H9.46094C8.58471 7.875 7.875 8.58471 7.875 9.46094V18.9766C7.875 19.8528 8.58471 20.5625 9.46094 20.5625H14.7477C15.6239 20.5625 16.3336 19.8528 16.3336 18.9766V18.4477C16.3336 18.1558 16.0973 17.9187 15.8047 17.9187C15.5129 17.9195 15.2758 18.1558 15.2758 18.4477Z",
    fill: "#EBF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 13.1617V12.5012C20.5625 11.9913 20.1478 11.5758 19.6371 11.5758H14.0863C13.5765 11.5758 13.1609 11.9905 13.1609 12.5012V13.1617H20.5625Z",
    fill: "#C2D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1617 14.2188V15.9371C13.1617 16.447 13.5765 16.8625 14.0871 16.8625H19.6379C20.1478 16.8625 20.5633 16.4478 20.5633 15.9371V14.2188H13.1617Z",
    fill: "#C2D8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_2528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpender);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Spender.3d9be2ce258a2bb7a790580391a66e39.svg";